import { en } from './en';
import { hu } from './hu';

export const translations = {
  en,
  hu
};
